<div class="flex flex-col">
  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
                'bg-gray-600': sharedService.userTheme === 'dark',
                'bg-indigo-50': sharedService.userTheme === 'light'}">

      <div class="flex flex-row padding10">
        <h5>Proficiency Reports</h5>
      </div>
    </mat-card>
  </div>

  <div class="flex flex-row">
    <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
        'bg-gray-600': sharedService.userTheme === 'dark',
        'bg-indigo-50': sharedService.userTheme === 'light'}">
      <mat-card-content>
        <div class="flex flex-col">

          <div style="overflow-x:auto">
            <div class="flex flex-row">
              <table class="mat-elevation-z8 w-full">
                <tr class="">
                  <th>Report Name </th>
                  <th>Description</th>
                  <th>
                  </th>
                </tr>
                <tr>
                  <td>Failed PT</td>
                  <td>Failed proficiencies for a given number of periods.(Default: 6)</td>
                  <td>
                    <div class="flex flex-row">

                      <div>
                        <button type="button" mat-raised-button color="primary" (click)="proficiencyReport()">
                          Run Report
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </mat-card-content>

    </mat-card>
  </div>

  <!-- Proficiency Failures Report -->
  <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" margin="1cm">
    <div class="flex flex-col" *ngIf="reportMode == 'list'">
      <div class="flex flex-row">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
          'bg-gray-700': sharedService.userTheme === 'dark',
          'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col">
              <h5>Failed PTs ({{list.length}})</h5>
              <span>Report Date: {{dateNow}}</span>
              <span style="width: 100%;border-top: 1px solid grey"></span>
              <div class="flex flex-row" style="padding-bottom: 10px;" *ngIf="list.length > 0">
                <div style="padding-right: 10px;">
                  <button type="button" mat-raised-button (click)="csv('failedPts')">
                    CSV
                  </button>
                </div>
                <!-- <div>
                  <button type="button" mat-raised-button (click)="pdf.saveAs('PtFailureReport.pdf')">
                    PDF
                  </button>
                </div> -->
              </div>
              <div style="overflow-x:auto">
                <div class="flex flex-row" *ngIf="list.length > 0">
                  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #TableSort="matSort"
                    class="mat-elevation-z8 w-full">
                    <ng-container matColumnDef="labName">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Lab Name</th>
                      <td mat-cell *matCellDef="let item">{{item.labName}}</td>
                    </ng-container>
                    <ng-container matColumnDef="accreditation">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Accreditation</th>
                      <td mat-cell *matCellDef="let item">{{item.accreditation}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="ptTest">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>PT Test</th>
                      <td mat-cell *matCellDef="let item">{{item.test}}</td>
                    </ng-container>
                    <ng-container matColumnDef="yr0_1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{year0}} (1)</th>
                      <td mat-cell *matCellDef="let item">{{item.year == year0 && item.period == 1? item.percent : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yr0_2">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{year0}} (2)</th>
                      <td mat-cell *matCellDef="let item">{{item.year == year0 && item.period == 2? item.percent : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yr0_3">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{year0}} (3)</th>
                      <td mat-cell *matCellDef="let item">{{item.year == year0 && item.period == 3? item.percent : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yr1_1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{year1}} (1)</th>
                      <td mat-cell *matCellDef="let item">{{item.year == year1 && item.period == 1? item.percent : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yr1_2">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{year1}} (2)</th>
                      <td mat-cell *matCellDef="let item">{{item.year == year1 && item.period == 2? item.percent : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="yr1_3">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{year1}} (3)</th>
                      <td mat-cell *matCellDef="let item">{{item.year == year1 && item.period == 3? item.percent : '' }}
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
              </div>
            </div>

          </mat-card-content>

        </mat-card>
      </div>

    </div>
  </kendo-pdf-export>

</div>